/* eslint-disable jsx-a11y/anchor-is-valid */
import { useEffect, useState } from 'react'
import noUiSlider from 'nouislider'
import { useLayout } from '../../core'
import { KTIcon } from '../../../helpers'
import { DefaultTitle } from './page-title/DefaultTitle'
import { ThemeModeSwitcher } from '../../../partials'
import moment from 'jalali-moment'
import { useMenuCountStore } from '../../../../app/core/state-management/states/menuCount'
import { Grid, Typography } from '@mui/material'
import { NotificationsModal } from '../../../partials/modals/notifications/NotificationsModal'

const HeaderToolbar = () => {
  const { classes } = useLayout()
  const { state } = useMenuCountStore();
  const [show, setShow] = useState(false)

  const { menuCountInfo } = state;
  useEffect(() => {
    const rangeSlider = document.querySelector('#kt_toolbar_slider')
    const rangeSliderValueElement = document.querySelector('#kt_toolbar_slider_value')

    if (!rangeSlider || !rangeSliderValueElement) {
      return
    }

    // @ts-ignore
    noUiSlider.create(rangeSlider, {
      start: [5],
      connect: [true, false],
      step: 1,
      format: {
        to: function (value) {
          const val = +value
          return Math.round(val).toString()
        },
        from: function (value) {
          return value
        },
      },
      range: {
        min: [1],
        max: [10],
      },
    })

    // @ts-ignore
    rangeSlider.noUiSlider.on('update', function (values, handle) {
      rangeSliderValueElement.innerHTML = values[handle]
    })

    const handle = rangeSlider.querySelector('.noUi-handle')
    if (handle) {
      handle.setAttribute('tabindex', '0')
    }

    // @ts-ignore
    handle.addEventListener('click', function () {
      // @ts-ignore
      this.focus()
    })

    // @ts-ignore
    handle.addEventListener('keydown', function (event) {
      // @ts-ignore
      const value = Number(rangeSlider.noUiSlider.get())
      // @ts-ignore
      switch (event.which) {
        case 37:
          // @ts-ignore
          rangeSlider.noUiSlider.set(value - 1)
          break
        case 39:
          // @ts-ignore
          rangeSlider.noUiSlider.set(value + 1)
          break
      }
    })
    return () => {
      // @ts-ignore
      rangeSlider.noUiSlider.destroy()
    }
  }, [])
  const newDate = moment(new Date()).locale('fa').format('dddd jDD jMMMM jYYYY')

  return (
    <div className='toolbar d-flex align-items-stretch'>
      {/* begin::Toolbar container */}
      <div
        className={`${classes.headerContainer.join(
          ' '
        )} py-6 py-lg-0 d-flex flex-column flex-lg-row align-items-lg-stretch justify-content-lg-between`}
      >
        <DefaultTitle />
        <div className='d-flex align-items-stretch overflow-auto pt-3 pt-lg-0'>


          {/* begin::Action wrapper */}
          <div className='d-flex align-items-center'>
            {/* begin::Label */}
            {/* <span className='fs-7 text-gray-700 fw-bolder pe-3 d-none d-xxl-block'>
              Quick Tools:
            </span> */}
            {/* end::Label */}

            {/* begin::Actions */}
            <div className='d-flex'>

              {/* begin::Action */}


              {/* end::Action */}
              <div className='d-flex align-items-center '>
                <span className='me-1'>{newDate}</span>

                {/* begin::Theme mode */}
                <div className='d-flex align-items-center'>
                  <ThemeModeSwitcher toggleBtnClass='btn btn-sm btn-icon btn-icon-muted btn-active-icon-primary' />
                </div>
              </div>
              <a

                className='btn btn-sm btn-icon btn-icon-muted btn-active-icon-primary position-relative'
                data-bs-toggle='modal'
                onClick={() => setShow(true)}
              >
                <Grid
                  display={'flex'}
                  alignItems={'center'}
                  justifyContent={'center'}
                  sx={{
                    backgroundColor: '#F1416C',
                    height: '20px',
                    width: '20px',
                    borderRadius: '50%',
                    position: 'absolute',
                    top: '-5px',
                    right: '15px'
                  }}
                >
                  {
                    <Typography variant='caption' sx={{ color: '#fff', fontSize: '8px', mt: '2px' }}>{menuCountInfo?.allNotification}</Typography>
                  }
                </Grid>
                <KTIcon iconName='notification' className='fs-1' />
              </a>
              {/* end::Theme mode */}
            </div>
            {/* end::Actions */}
          </div>
          {/* end::Action wrapper */}
        </div>
        {/* end::Toolbar container */}
      </div>
      <NotificationsModal open={show} onClose={() => setShow(false)} />
      </div>
  )
}

export { HeaderToolbar }
